import React, { useContext, useEffect, useState } from "react";
import "./Payment_Summary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// import Confirm_Addess_Modal from "../../common_components/common_modal/confirm_addess_modal/Confirm_Addess_Modal";
import { faBuilding, faTags, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Offcanvas } from "react-bootstrap";
// import Coupon_Card from "../../common_components/coupon_card/Coupon_Card";
import { useNavigate } from "react-router-dom";
import Pink_Btn from "../../../../../common/common_btn/pink_btn/Pink_Btn";
import Light_Black_Btn from "../../../../../common/common_btn/light_black_btn/Light_Black_Btn";
import Confirm_delivery_add_offcanvas from "../../../../../common/offcanvas/confirm-delivery-add-offcanvas/Confirm_delivery_add_offcanvas";
import { Context } from "../../../../../../utils/context";
import Login_Layout_Modal from "../../../../../common/modals/login-signup-modals/Login_Layout_Modal";
import { getAllOrderAddress } from "../../../../../../features/order/orderSlice";
import { useDispatch, useSelector } from "react-redux";
import Cancel_Order_btn from "../../../../../common/common_btn/cancel_Order_btn/Cancel_Order_btn";

const Payment_Summary = ({
  data,
  allCart,
  viewAllSummary,
  isCheckoutPage,
  checkout_btn,
  checkoutAction,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [showOffCanvas, setShowOffCanvas] = useState(false);
  const [addoffcanvas, setAddoffcanvas] = useState(false);
  const [modelType, setModelType] = useState("");
  const [selectLogin, setSelectLogin] = useState(false);
  const { signin } = useContext(Context);

  const navigate = useNavigate();
  const [addCartBTNShow, setaddCartBTNShow] = useState(false);

  return (
    <>
      <div className="payment_summary_div">
        {!viewAllSummary && (
          <h3 className="heading">
            <img
              src="/assets/images/payment_summary/icon.png"
              className="icon_img"
            />{" "}
            Payment Summary <span className="inner_text">(incl GST)</span>
          </h3>
        )}

        <div className="summary">
          <div className="row-divider">
            <div className="title_div">
              <p>Total no. of items</p>
            </div>

            <div className="qty_div">
              <p>{data?.no_of_item || "0"} Nos.</p>
            </div>
          </div>

          <div className="row-divider">
            <div className="title_div">
              <p>Cart Total</p>
            </div>
            <div className="qty_div">
              <p>₹ {data?.total_selling_price || "0"}</p>
            </div>
          </div>

          {isCheckoutPage && (
            <>
              <div className="row-divider">
                <div className="delivery_title_div">
                  <p>Delivery Charges</p>
                </div>

                <div className="qty_div">
                  <p>₹ {data?.total_delivery_charges || 0.0}</p>
                </div>
              </div>

              <div className="row-divider">
                <div className="delivery_title_div">
                  <p>Coupon Discount</p>
                </div>

                <div className="qty_div">
                  <p>₹ {data?.total_coupon_discount || 0.0}</p>
                </div>
              </div>
            </>
          )}

          {/* <div className="row-divider">
            <div className="title_div">
              <p>GST</p>
            </div>

            <div className="qty_div">
              <p>₹ {data?.total_tax || "0"}</p>
            </div>
          </div> */}

          <div className="row-divider">
            <div className="title_div">
              <p>Total Savings</p>
            </div>

            <div className="qty_div">
              <p>₹ {data?.total_savings || "0"}</p>
            </div>
          </div>

          <div className="total_div">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_title_div">
                  <p>Grand Total</p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                <div className="total_qty_div">
                  <p>₹ {data?.grand_total || "0"}</p>
                </div>
              </div>
            </div>
          </div>

          {!isCheckoutPage && (
            <>
              <div className="forgot_div">
                <p className="forgot_text">Forgot Something?</p>
                <div className="add_btn_div">
                  <Light_Black_Btn
                    btnText="+ Add more items"
                    onClick={() => {
                      navigate("/all-products");
                    }}
                  />
                </div>
              </div>

              <div className="checkout_btn">
                <Pink_Btn
                  btnText="Proceed To Checkout"
                  onClick={() => {
                    if (signin) {
                      if (allCart?.data?.data?.length > 0) {
                        setAddoffcanvas(true);
                      } else {
                        alert("No Items Found in Cart");
                        navigate("/all-products");
                      }
                    } else {
                      setModelType("select_login");
                      setSelectLogin(true);
                    }
                  }}
                />
                <br/>

                <Cancel_Order_btn
                  btnText="Continue Shopping"
                  onClick={() => navigate("/all-products")}
                />
              </div>
            </>
          )}
        </div>
      </div>

      {/* {isCheckoutPage && (
        <div className="payment_summary_div coupon_main_div">
            
          <div className="coupon_div">
            <div className="special_div">
              <img
                src="/assets/images/checkout/green_discount.png"
                className="discount_img"
              />
              <p className="special_text">Something Special for you!</p>
            </div>
            <div className="coupons_div">
              <div className="left_side">
                <FontAwesomeIcon icon={faTags} className="tag_icon" />
                <span className="coupon_text">Coupons</span>
              </div>
              <div className="btn_holder">
                <button
                  className="black_btn"
                  onClick={() => {
                    setShowOffCanvas(true);
                  }}
                >
                  View
                </button>
              </div>
            </div>
          </div>

          <div className="checkout_btn">
                        <Green_Btn btn_name={checkout_btn} onClick={checkoutAction} />
                    </div>
        </div>
      )} */}
      {/* 
            <Confirm_Addess_Modal
                show={showModal}
                onHide={() => { setShowModal(false) }}
            /> */}

      <Offcanvas
        className="right_bottom_offcanvas"
        placement="bottom"
        show={showOffCanvas}
        onHide={() => {
          setShowOffCanvas(false);
        }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faTags} className="tag_icon" /> Coupons
          </Offcanvas.Title>
          <div
            className="icon_holder"
            onClick={() => {
              setShowOffCanvas(false);
            }}
          >
            <FontAwesomeIcon icon={faXmark} className="close_icon" />
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="coupon_cards_div">
            {/* <Coupon_Card showtc />
                        <Coupon_Card /> */}
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Confirm_delivery_add_offcanvas
        show={addoffcanvas}
        onHide={() => setAddoffcanvas(false)}
      />
      <Login_Layout_Modal
        modalType={modelType}
        show={selectLogin}
        onHide={() => setSelectLogin(false)}
      />
    </>
  );
};

export default Payment_Summary;
